import { Attribute, CreateAttribute } from '@frontend/attribute/types';
import { CommonMessage } from '@frontend/lang';
import { FormattedMessage } from 'react-intl';

import DraggableList from '../../../../attribute/attribute-create/draggable-list';
import CreateModal from '../../../../modal/create-modal/create-modal.component';
import { useCreateAttributeModal } from './create-attribute-modal.controller';

export const CreateAttributeModal = () => {
    const viewProps = useCreateAttributeModal();

    return (
        <CreateModal<Attribute, CreateAttribute>
            required={['name']}
            order={['name']}
            formId={viewProps.formId}
            append={
                <div className='mt-6 flex w-full flex-col gap-2'>
                    <div className='flex flex-row justify-between font-medium'>
                        <span>
                            <FormattedMessage
                                id='attribute.values'
                                defaultMessage='Values'
                            />
                        </span>
                        <span
                            className='text-brand-primary hover:text-brand-secondary cursor-pointer'
                            onClick={viewProps.addValue}>
                            <FormattedMessage
                                id='attribute.add-another-value'
                                defaultMessage='Add another value'
                            />
                        </span>
                    </div>
                    <DraggableList
                        items={viewProps.values.map((value, index) => ({ id: index.toString(), value }))}
                        dragCallback={viewProps.onDragCallback}
                        onChange={viewProps.updateValue}
                        onRemove={viewProps.removeValue}
                    />
                </div>
            }
            type={viewProps.type}
            onSubmit={viewProps.onSubmit}
            submitDisabled={viewProps.submitDisabled}
            subForms={
                new Map([
                    [
                        CommonMessage.DETAIL.TRANSLATIONS,
                        {
                            order: ['name_nl_be', 'name_en_us', 'name_fr_fr', 'name_de_de'],
                            collapsible: true,
                            defaultCollapsed: true
                        }
                    ]
                ])
            }
        />
    );
};
